// extracted by mini-css-extract-plugin
export default {"wrapper":"Xt-z","button":"Yt-z","alternate":"Zt-z","disabled":"_t-z","paymentWarning":"au-z","fadeIn":"bu-z"};